import { render, staticRenderFns } from "./activityProduct2.vue?vue&type=template&id=3b7b7255&scoped=true"
import script from "./activityProduct2.vue?vue&type=script&lang=js"
export * from "./activityProduct2.vue?vue&type=script&lang=js"
import style0 from "./activityProduct2.vue?vue&type=style&index=0&id=3b7b7255&lang=less"
import style1 from "./activityProduct2.vue?vue&type=style&index=1&id=3b7b7255&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b7b7255",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\workspace\\ysorder\\order_admin_client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3b7b7255')) {
      api.createRecord('3b7b7255', component.options)
    } else {
      api.reload('3b7b7255', component.options)
    }
    module.hot.accept("./activityProduct2.vue?vue&type=template&id=3b7b7255&scoped=true", function () {
      api.rerender('3b7b7255', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/marketing/activity/activityProduct2.vue"
export default component.exports